<template>
  <div class="container">
    <top-header ref="tit"></top-header>
    <div class="content">
      <div class="box">
        <div class="cont">
          <div
            @click="titBtn('1')"
            class="cus"
            :class="activeTit == '1' ? 'active' : ''"
          >
            <span>期刊文献</span>
            <div v-if="activeTit == '1'" class="bottom_line"></div>
          </div>
          <div
            @click="titBtn('2')"
            class="cus"
            :class="activeTit == '2' ? 'active' : ''"
          >
            <span>新闻咨询</span>
            <div v-if="activeTit == '2'" class="bottom_line"></div>
          </div>
        </div>
        <div class="cont_1" v-show="activeTit == '1'">
          <ul>
            <li
              :class="activeSel == item.name ? 'activeSelTit' : ''"
              @click="selTit(item)"
              class="btn"
              v-for="(item, index) in list"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="cont_1" v-show="activeTit == '2'">
          <ul>
            <li
              :class="activeSel1 == item.name ? 'activeSelTit' : ''"
              @click="selTit1(item)"
              class="btn"
              v-for="(item, index) in list1"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="cont_2">
          <el-input v-model="value" placeholder="" size="normal">
            <i
              slot="suffix"
              class="el-icon-search"
              @click="search"
              style="font-weight: 600"
            ></i>
          </el-input>
          <!-- <button class="btn" >搜索</button> -->
        </div>
        <!-- <div class="cont_3">
          <div class="cont_3_1">搜索历史:</div>
          <div class="cont_3_2">删除搜索历史</div>
        </div> -->
      </div>
    </div>
    <cenfooter class="footer"></cenfooter>
  </div>
</template>

<script>
import topHeader from "../components/home/headears.vue";
import cenfooter from "../components/home/footers.vue";
export default {
  components: {
    topHeader,
    cenfooter,
  },
  data() {
    return {
      value: "",
      activeValue: "",
      activeTit: "1",
      activeSel: "中华医学期刊",
      activeSel1: "百度",
      list: [
        {
          name: "中华医学期刊",
        },
        {
          name: "中国知网",
        },
        {
          name: "人卫图书",
        },
        {
          name: "SCI外文期刊",
        },
        // {
        //   name: "其他资源",
        // },
      ],
      list1: [
        {
          name: "百度",
        },
        {
          name: "微博",
        },
      ],
    };
  },
  mounted() {
    this.$refs.tit.isShow = false;
  },
  methods: {
    titBtn(e) {
      this.activeTit = e;
    },
    selTit(e) {
      this.activeSel = e.name;
    },
    selTit1(e) {
      this.activeSel1 = e.name;
    },

    search() {
      var herf = null;
      var temp = null;
      var temp1 = null;
      if (this.value.trim() == "") {
        this.$message({
          message: "请输入关键词",
          type: "warning",
        });
        return;
      }
      if (this.activeTit == "2") {
        if (this.activeSel1 == "百度") {
          var herf = "https://www.baidu.com/s?";
          var temp =
            herf +
            `ie=utf-8&f=8&rsv_bp=${this.value}&rsv_idx=1&tn=baidu&wd=${this.value}&fenlei=256&rsv_pq=b29ff6220000fd7e&rsv_t=204fJLwgF4lGrvLALuRT9mEF6seYPiq913i%2BP0AuvbS4QyDbpIAr0tB6DEs&rqlang=cn&rsv_enter=0&rsv_dl=tb&rsv_sug3=2&rsv_sug1=1&rsv_sug7=100&rsv_btype=i&prefixsug=z&rsp=2&inputT=4043&rsv_sug4=6322`;
          window.open(temp, "_blank");
        }
        if (this.activeSel1 == "微博") {
          var herf = "https://s.weibo.com/weibo?";
          var temp = herf + `q=${this.value}`;
          window.open(temp, "_blank");
        }
      }
      if (this.activeTit == "1") {
        if (this.activeSel == "中华医学期刊") {
          herf = "http://yiigle.meddata.com.cn/#/searchIndex?";
          temp = herf + `encryption=Boku_2020&name=科教资讯&main=${this.value}`;
          window.open(temp, "_blank");
        }
        if (this.activeSel == "中国知网") {
          let myWindow = window.open(
            "https://login.cnki.net/TopLogin/api/loginapi/Login?callback=jQuery18203555834210766615_1657872142494&userName=med_books&pwd=tgbyhn&isAutoLogin=true&p=0&_=1630633458389"
          );
          herf = "https://chkdx.cnki.net/KNS/Brief/singleResult.aspx?code=CHKD";
          temp = herf + "&kw=" + this.value;
          setTimeout(() => {
            myWindow.location.href = temp;
          }, 50);
        }
        if (this.activeSel == "人卫图书") {
          herf =
            "http://pmphbook.medbooks.com.cn:8850/medical/medbooks/resource/search.zhtml?";
          temp =
            herf +
            "querys=" +
            this.value +
            "&AccureType=&SearchType=1&SType=WestMedBook";
          window.open(temp, "_blank");
        }

        if (this.activeSel == "SCI外文期刊") {
          herf = `http://www.meddata.com.cn/?loginName=kjzx&password=kj123456`;
          temp = herf + "&exp=" + this.value;
          window.open(temp, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
}
.content {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-top: 110px;
  .box {
    width: 724px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
  }

  .cus {
    cursor: pointer;
    font-size: 30px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: 400;
    color: #303133;
    line-height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      display: block;
    }

    .bottom_line {
      width: 60px;
      height: 4px;
      background: #4273b2;
      border-radius: 2px;
    }
  }

  .active {
    color: #13509f;
  }

  .cont {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    font-size: 18px;
    margin-bottom: 40px;
  }
  .cont_1 {
    width: 100%;
  }
  .cont_1 ul {
    .activeSelTit {
      background: #4273b2;
      color: #fff;
    }
    display: flex;
    margin-bottom: 20px;
    li {
      cursor: pointer;
      padding: 6px 20px;
      text-align: center;
      border: 1px solid #4273b2;
      background-color: #fff;
      color: #4273b2;
      margin-right: 10px;
      border-radius: 25px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 25px;
    }
  }
  .cont_2 {
    width: 100%;
    ::v-deep .el-input__suffix {
      display: flex;
      align-items: center;
      padding-right: 15px;
      color: #13509f;
      font-size: 28px;
      cursor: pointer;
    }

    ::v-deep .el-input__inner {
      border: 2px solid #13509f;
      height: 66px;
      box-shadow: 2px 2px 2px 2px #4273b2;
      box-shadow: 0px 1px 3px 0px #4273b2 inset;
      border-radius: 43px;
      border: 2px solid #13509f;
    }

    ::v-deep .el-input__inner {
      font-size: 22px;
    }
    .btn {
      width: 6%;
      transition: 0.3s;
      border: 0;
      text-align: center;
      height: 40px;
      background-color: #0b70c1;
      font-size: 13px;
      color: #fff;
      cursor: pointer;
      border-radius: 0 5px 5px 0;
      // transform: translateY(1px);
    }
  }
  // .cont_3 {
  //   display: flex;
  //   justify-content: space-between;
  //   width: 51%;
  //   height: 40px;
  //   background-color: #f2f6fc;
  //   margin: 20px auto 0;
  //   transform: translateX(30px);
  //   padding: 10px;
  //   .cont_3_1{
  //     color: #0b70bb;
  //     font-weight: 600;
  //   }
  //   .cont_3_2{
  //     color: #d5d8de;
  //   }
  // }
}

.footer {
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>